const qualityContent = [
  {
    img: 'https://static.base.co.id/content-quality-page-1.jpg',
    imageHeight: 535,
    imageWidth: 384,
    title: 'We start at the source, globally',
    text: 'We fell in love with the idea to have a skincare ingredient that is also food-grade and proven to be effective. Our Research & Development team tirelessly search for the effective, ethical and sustainable plant-derived ingredients from various countries. They have established partnerships with local plant-derived ingredient suppliers to ensure we get the best ingredients for your skin.',
  },
  {
    img: 'https://static.base.co.id/content-quality-page-2.jpg',
    imageHeight: 996,
    imageWidth: 771,
    title: 'We produce with care, locally',
    text: 'We proud that each of the products are produced here, locally in Indonesia with a Good Manufacturing Practice (GMP) facilities, which each of the products are certified by BPOM. We are also raising the bar when it comes into a cleaner beauty product by avoiding harsh preservatives and solvents.',
  },
  {
    img: 'https://static.base.co.id/content-quality-page-3.jpg',
    imageHeight: 1002,
    imageWidth: 668,
    title: 'We do continuous test, everytime',
    text: 'We sourced our raw, active and inactive ingredients from all-over parts of the world. To ensure we meet the highest safety standard, we are continuously do the testing for both raw and final products in our Good Manufacturing Practice (GMP) facilities in Indonesia. We are also focusing on the products’ improvement, and periodically add proven, new effective ingredients on our products. So your skincare is always keep up with the trend.',
  },
]

export default qualityContent
